module.exports = __webpack_public_path__ + "static/4bagr-logo-scoreholio-1e31f1ea0ba5d5dcbad305519209b0e0.png";